import { Component } from "react";
import Logo from "@/components/Logo";
import { CTA } from "@/components/system";

// A crash in any single section must never blank an entire lead-generating page.
export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-ground px-6 text-center">
          {/* Was a one-off 12px mono wordmark at the widest tracking on the
              site — a fourth way of writing the brand name, rendered in the
              one place nobody is meant to linger. The real mark instead. */}
          <Logo className="mb-8" />
          <h1 className="font-display text-h1 uppercase text-bone">
            Something went wrong.
          </h1>
          <p className="measure mt-5 font-body text-body-l text-mute">
            Reload the page, or reach us directly at{" "}
            <a
              href="mailto:contact@kyrosity.ai"
              className="text-bone underline transition-colors duration-hover ease-gate hover:text-gold"
            >
              contact@kyrosity.ai
            </a>
            .
          </p>
          {/* The fifth hand-rolled gold button on the site, down to its own
              weight and tracking. It is the same button as everywhere else. */}
          <CTA href="/" className="mt-10">
            Back to Home
          </CTA>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
